'use client'

import { Toaster as StudioToaster } from '@repo/studio-components-toast'

export function Toaster() {
  return <StudioToaster />
}
